import BootstrapField from '../utility/BootstrapField';
// import LaneClosureRequestBlock from '../models/LaneClosureRequestBlock';
// import LaneClosureRequestMessage from '../models/LaneClosureRequestMessage';
// import Contravention from '../models/Contravention';
// import Attachment from '../models/Attachment';


export default class ConflictingLaneClosureRequest {

	constructor(data) {
		if (!data) {
			data = {}
		}
		Object.assign(this, {
			id: data.id || null,
			requesterId: data.requesterId || null,
			ownerId: data.ownerId || null,
			trafficManagementRef: new BootstrapField({
				value: data.trafficManagementRef || null,
				required: true,
			}),
			directionId: new BootstrapField({
				value: data.directionId || null,
				required: true,
			}),
			natureOfWorkId: new BootstrapField({
				value: data.natureOfWorkId || null,
				required: true,
			}),
			affectedStreet: new BootstrapField({
				value: data.affectedStreet || null,
				required: true,
			}),
			firstCrossStreet: new BootstrapField({
				value: data.firstCrossStreet || null,
				required: true,
			}),
			lastCrossStreet: new BootstrapField({
				value: data.lastCrossStreet || null,
				required: true,
			}),
			conflictType: new BootstrapField({
				value: data.conflictType || null,
				required: true,
			}),
			fromDate: new BootstrapField({
				value: data.fromDate || null,
				required: true,
				type: BootstrapField.Types.date,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter a valid requested start date',
			}),
			toDate: new BootstrapField({
				value: data.toDate || null,
				required: true,
				type: BootstrapField.Types.date,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter a valid estimated completion date',
			}),
			fromTime: new BootstrapField({
				value: data.fromTime || null,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				// required: true,
				invalidMessage: 'Please enter an estimated start time',
			}),
			toTime: new BootstrapField({
				value: data.toTime || null,
				// required: true,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter an estimated completion time',
			}),

			newFromDate: new BootstrapField({
				value: data.newFromDate || null,
				required: true,
				type: BootstrapField.Types.date,
				invalidMessage: 'Please enter a valid requested start date',
			}),
			newToDate: new BootstrapField({
				value: data.newToDate || null,
				required: true,
				type: BootstrapField.Types.date,
				invalidMessage: 'Please enter a valid estimated completion date',
			}),
			newFromTime: new BootstrapField({
				value: data.newFromTime || data.newFromDate,
				required: true,
				type: BootstrapField.Types.date,
				invalidMessage: 'Please enter a valid requested start date',
			}),
			newToTime: new BootstrapField({
				value: data.newToTime || data.newToDate,
				required: true,
				type: BootstrapField.Types.date,
				invalidMessage: 'Please enter a valid estimated completion date',
			}),

			conflictDuration: new BootstrapField({
				value: typeof data.conflictDuration === 'number' ? data.conflictDuration : null,
			}),
			conflictFromDate: new BootstrapField({
				value: typeof data.conflictFromDate === 'number' ? data.conflictFromDate : null,
			}),
			conflictToDate: new BootstrapField({
				value: typeof data.conflictToDate === 'number' ? data.conflictToDate : null,
			}),

		});
	}

	validate() {

		this.toTime.invalidMessage = 'Please enter a valid end time';
		this.toDate.invalidMessage = 'Please enter a valid estimated completion date';
		let flag = true;

		let errors = [];


		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		// var differences = DeepDiff.diff(originalLaneClosureData.getRawValue(),  this.getRawValue());
		// return !IsEqual(originalLaneClosureData.getRawValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalLaneClosureData);
	}
	saveChanges() {
		// originalLaneClosureData = CloneDeep(this);
	}
}